import { Textarea } from '@mantine/core';

export default Textarea.extend({
	defaultProps: {
		size: 'xs'
	}
});
